//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockInputItem } from './WebsiteBlockInputItem';
import { WebsiteBlockType, WebsiteBlockReviewsType } from './Enums';

export class WebsiteBlockReviewsInputItem extends WebsiteBlockInputItem {
    Title: string | null = null;
    TeacherIDs: string[] = [];
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.Reviews;
    ReviewsType: WebsiteBlockReviewsType = WebsiteBlockReviewsType.Default;

    constructor(initializer?: Partial<Omit<WebsiteBlockReviewsInputItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockReviewsInputItem";
}
